import Icon from "@/components/elements/icons/Icons"
import { IconLibrary } from "@/interfaces/IconLibrary"



const DragAndDropControlContent= ({className, color, iconName, text} : {className?: string, iconName: IconLibrary, text: string, color?: string}) => {   

    return (
        <div className={`button-content ${className}`}>
            <Icon iconName={iconName} sizeInPx="12" color={`${color ?? "#0570B6"}`}/>

            <span>{text}</span>
        </div>
    )
}

export default DragAndDropControlContent